import React from 'react';
import AccountRecoveryContainer from '../components/AccountRecovery/AccountRecovery';

const AccountRecovery = (): JSX.Element => {
    return <AccountRecoveryContainer />;
};

export default AccountRecovery;
